import Box from '@mui/material/Box';
import React from 'react';
import Stack from '@mui/material/Stack';
import { ReactComponent as ThumbsUpEmoji } from 'assets/svg/thumbsup_emoji.svg';
import { ReactComponent as HeartEmoji } from 'assets/svg/heart_emoji.svg';
import { ReactComponent as CelebrateEmoji } from 'assets/svg/celebrate_emoji.svg';
import { ReactComponent as HandsEmoji } from 'assets/svg/hands_emoji.svg';
import { styled } from '@mui/material/styles';
import IconButton from 'components/IconButton';

export const EMOJIES = [
  { Icon: ThumbsUpEmoji, value: 'thumbs_up' },
  { Icon: HeartEmoji, value: 'heart' },
  { Icon: CelebrateEmoji, value: 'party' },
  { Icon: HandsEmoji, value: 'folded_hands' },
];

const Reactions = ({ message, onReaction }) => {
  if (message.is_message_reaction_enabled === '1') {
    return (
      <Stack direction="row" spacing={1} justifyContent="center" mt={2}>
        {EMOJIES.map(({ Icon, value }) => (
          <IconButton
            key={value}
            onClick={() => onReaction({ value, Icon })}
            icon={<Icon />}
          />
        ))}
      </Stack>
    );
  }
  return null;
};

export default Reactions;
